import { ICellRendererParams } from "ag-grid-community";
import { observer } from "mobx-react-lite";

import type { RequestRow } from "../requestLogGridTypes";

import { HydrationPendingCell, isRequestRowHydrating } from "./HydrationPendingCell";

import { useUser } from "@/context/user-context";

export const PromptNameCellRenderer = observer(({ data }: ICellRendererParams<RequestRow>) => {
  const userContext = useUser();
  const promptName = data?.prompt_name;
  const promptId = data?.prompt_id;
  const promptVersionNumber = data?.prompt_version_number;

  if (isRequestRowHydrating(data)) {
    return <HydrationPendingCell />;
  }

  if (!promptName || !promptId || !promptVersionNumber) {
    return <span className="text-gray-400">—</span>;
  }

  // Do not copy table/sidebar filters onto the prompt page — surfaces stay independent.
  const promptHref = `/workspace/${userContext?.activeWorkspaceId}/prompt/${promptId}/version/${promptVersionNumber}`;

  return (
    <a
      href={promptHref}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 hover:text-blue-800 hover:underline"
      onClick={e => e.stopPropagation()}
    >
      {promptName} [#{promptVersionNumber}]
    </a>
  );
});
